var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var StringFilter_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { squel } from '@symon-ai/wisepipe-squel';
import { Filter, FilterType } from './filter';
import { stringFilterSchemaValidation } from '../validations.generated';
export var StringFilterOp;
(function (StringFilterOp) {
    StringFilterOp["CONTAINS"] = "contains";
    StringFilterOp["EQUAL"] = "equal";
    StringFilterOp["STARTS_WITH"] = "starts_with";
    StringFilterOp["ENDS_WITH"] = "ends_with";
})(StringFilterOp || (StringFilterOp = {}));
const VALUE_MAX_LENGTH = 1000;
export const stringFilterSchema = {
    $id: 'urn:wisepipe-common-computation:StringFilter',
    type: 'object',
    properties: {
        values: {
            type: 'array',
            items: { type: ['string', 'null'], maxLength: VALUE_MAX_LENGTH }
        }
    },
    if: {
        anyOf: [{ required: ['op'] }, { required: ['match'] }]
    },
    then: {
        properties: {
            op: { type: 'string', enum: Object.values(StringFilterOp) },
            match: { type: 'string', maxLength: VALUE_MAX_LENGTH }
        },
        required: ['op', 'match']
    }
};
let StringFilter = StringFilter_1 = class StringFilter extends Filter {
    constructor(column, op, match, values) {
        super(column, FilterType.STRING);
        if (op !== undefined)
            this.op = op;
        if (match !== undefined)
            this.match = match;
        if (values)
            this.values = values;
        JSON.validate(this, StringFilter_1);
    }
    get sql() {
        const expr = squel.expr();
        if (this.op) {
            expr.or(this.getOpConstraint());
        }
        if (this.values) {
            const strs = this.values.filter((v) => v !== null);
            strs.forEach((v) => expr.or(this.getValueConstraint(v)));
            if (strs.length < this.values.length) {
                expr.or(this.getValueConstraint(''));
                expr.or(`"${this.column}" IS NULL`);
            }
        }
        return expr;
    }
    getOpConstraint() {
        let op;
        let match = this.match?.replace(/'/g, `''`);
        if (this.op && [StringFilterOp.CONTAINS, StringFilterOp.STARTS_WITH, StringFilterOp.ENDS_WITH].includes(this.op)) {
            match = match?.replace(/\\/g, `\\\\`).replace(/%/g, `\\%`).replace(/_/g, `\\_`);
        }
        switch (this.op) {
            case StringFilterOp.CONTAINS:
                op = `LIKE '%${match}%' ESCAPE '\\'`;
                break;
            case StringFilterOp.STARTS_WITH:
                op = `LIKE '${match}%' ESCAPE '\\'`;
                break;
            case StringFilterOp.ENDS_WITH:
                op = `LIKE '%${match}' ESCAPE '\\'`;
                break;
            case StringFilterOp.EQUAL:
                op = `= '${match}'`;
                break;
            default:
                break;
        }
        return `"${this.column}" ${op}`;
    }
    getValueConstraint(value) {
        value = value.replace(/'/g, `''`);
        return `"${this.column}" = '${value}'`;
    }
};
StringFilter.VALUE_MAX_LENGTH = VALUE_MAX_LENGTH;
StringFilter = StringFilter_1 = __decorate([
    JsonSchemaV2(stringFilterSchema, stringFilterSchemaValidation),
    JsonDiscriminatorValue(FilterType.STRING)
], StringFilter);
export { StringFilter };
//# sourceMappingURL=stringFilter.js.map